import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1 className="page-title">업무안내</h1>
            <h2 className="main-quote">
              최고의 세무 서비스를 제공합니다
            </h2>
            <p className="description">
              교차검증으로 꼼꼼한 고객 맞춤 세무 서비스를 완성합니다
            </p>
          </div>
        </div>
      </section>

      {/* 기장업무 */}
      <section className="bookkeeping-section">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">기장업무</h2>
            <p className="section-description">
              사업 세금 신고의 기본, 정확한 장부 작성과 예상세액 보고로 <br />사전절세 전략까지 완벽하게 지원하는 기장 서비스입니다
            </p>
          </div>
          
          <div className="pricing-grid fade-in-up">
            <div className="pricing-card">
              <h3>개인사업자</h3>
              <p className="card-description">개인사업자 장부작성 및 세무신고</p>
              <div className="pricing-item">
                <span className="pricing-label">월 기장수수료</span>
                <span className="pricing-value">80,000원~</span>
              </div>
              <div className="pricing-item">
                <span className="pricing-label">연 세무조정</span>
                <span className="pricing-value">300,000원~</span>
              </div>
              <button className="quote-btn">견적 문의</button>
            </div>

            <div className="pricing-card">
              <h3>법인</h3>
              <p className="card-description">법인 장부작성 및 세무신고</p>
              <div className="pricing-item">
                <span className="pricing-label">월 기장수수료</span>
                <span className="pricing-value">120,000원~</span>
              </div>
              <div className="pricing-item">
                <span className="pricing-label">연 세무조정</span>
                <span className="pricing-value">400,000원~</span>
              </div>
              <button className="quote-btn">견적 문의</button>
            </div>

            <div className="pricing-card featured">
              <h3>병의원</h3>
              <p className="card-description">의료기관 전문 장부작성 및 세무신고</p>
              <div className="pricing-item">
                <span className="pricing-label">월 기장수수료</span>
                <span className="pricing-value">150,000원~</span>
              </div>
              <div className="pricing-item">
                <span className="pricing-label">연 세무조정</span>
                <span className="pricing-value">400,000원~</span>
              </div>
              <button className="quote-btn">견적 문의</button>
            </div>
          </div>

          <div className="notice-box">
            <h4>참고사항</h4>
            <ul>
              <li>세무조정비용은 연 1회, 소득신고 이후 별도입니다</li>
              <li>사업장 매출규모, 종업원수 등 사업장 특성에 따라 기장수수료는 차등적용됩니다</li>
              <li>성실신고대상사업자는 기본수수료가 달라질 수 있습니다 (세액공제 적용을 위한 협의사항)</li>
              <li>정확한 견적은 상담을 통해 사전에 안내해드립니다</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 재산제세 수수료 */}
      <section className="property-tax-section">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">재산제세 업무</h2>
            <p className="section-description">협업으로 다양한 방안을 모색하고 제시합니다</p>
          </div>
          
          <div className="pricing-grid fade-in-up">
            <div className="pricing-card">
              <h3>기본상담</h3>
              <p className="card-description">재산제세 관련<br />기본 상담 서비스</p>
              <div className="pricing-main">100,000원</div>
              <button className="quote-btn">상담신청</button>
            </div>

            <div className="pricing-card">
              <h3>양도·증여 신고</h3>
              <p className="card-description">부동산, 주식등 과세물건<br />양도소득세 및 증여세 신고</p>
              <div className="pricing-main">300,000원~</div>
              <button className="quote-btn">상담신청</button>
            </div>

            <div className="pricing-card">
              <h3>상속세 신고</h3>
              <p className="card-description">기본수수료<br />자료검토부터 납부서 전달</p>
              <div className="pricing-main">2,000,000원~</div>
              <button className="quote-btn">상담신청</button>
            </div>

            <div className="pricing-card">
              <h3>컨설팅</h3>
              <p className="card-description">절세전략 수립 및 기타자문<br />양도·상속,증여·지방세</p>
              <div className="pricing-main">500,000원~</div>
              <button className="quote-btn">상담신청</button>
            </div>
          </div>
        </div>
      </section>

      {/* 경정청구 및 조세불복 */}
      <section className="tax-appeal-section">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">경정청구 및 조세불복</h2>
            <p className="section-description">성공 시에만 수수료를 받습니다</p>
          </div>
          
          <div className="pricing-grid fade-in-up">
            <div className="pricing-card">
              <h3>세무컨설팅</h3>
              <p className="card-description">
                상황별·사업모델별 절세 검토<br />
                향후 신고 방향 모색, 절세 전략실행<br />
                대상 : 법인세, 개인소득세
              </p>
              <div className="pricing-main">경감세액의<br />5% ~ 25%</div>
              <button className="quote-btn">상담신청</button>
            </div>

            <div className="pricing-card">
              <h3>경정청구</h3>
              <p className="card-description">
                이미 납부된 세금에 대한 검토<br />
                과다납부된 세금 환급청구<br />
                대상 : 양도소득세, 법인세, 종합소득세
              </p>
              <div className="pricing-main">경감세액의<br />5% ~ 25%</div>
              <button className="quote-btn">상담신청</button>
            </div>

            <div className="pricing-card">
              <h3>조세불복</h3>
              <p className="card-description">
                조사 결과에 대한 이의신청 및 심판청구<br />
                기조사결과에 대한 전면 재검토<br />
                과세당국 처분 법리 재해석
              </p>
              <div className="pricing-main">경감세액의<br />5% ~ 25%</div>
              <button className="quote-btn">상담신청</button>
            </div>
          </div>

          <div className="notice-box">
            <h4>성과 기반 수수료 안내</h4>
            <ul>
              <li>성공 시에만 수수료를 받는 No Cure, No Pay 방식입니다</li>
              <li>경감세액의 규모에 따라 경감세액의 5% ~ 25% 차등 적용됩니다</li>
              <li>미적용된 각종 세액공제 및 조세혜택을 전반적으로 검토해드립니다</li>
              <li>소급 적용 가능 기간은 법정 기한 내에서 진행됩니다</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 투명한 가격 정책 */}
      <section className="transparent-pricing">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">투명한 가격 정책</h2>
            <p className="section-description">명확하고 합리적인 수수료로 최고의 세무 서비스를 제공합니다.</p>
          </div>
          
          <div className="features-grid fade-in-up">
            <div className="feature-card">
              <h3>투명한 견적</h3>
              <p>숨겨진 비용 없이<br />명확한 견적을 제시해드립니다</p>
            </div>
            <div className="feature-card">
              <h3>합리적 가격</h3>
              <p>사업장 규모와 특성에 맞는<br />합리적인 수수료 책정</p>
            </div>
            <div className="feature-card">
              <h3>성과 기반</h3>
              <p>경정청구 및 조세불복은<br />성공 시에만 수수료를 받습니다</p>
            </div>
          </div>
        </div>
      </section>

      {/* 견적 문의 */}
      <section className="quote-section">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">세금으로 고민하거나 걱정하고 계시다면</h2>
            <p className="section-description">
              부담없이 문의해주세요. 상황에 맞는 최적의 솔루션을 제시해드립니다.
            </p>
            
            <div className="quote-buttons">
              <Link to="/contact" className="btn btn-primary">문의하기</Link>
              <button className="btn btn-kakao">💬 카톡상담</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
